import { useState, useEffect } from 'react';
import { useLocation, Navigate } from 'react-router-dom';

import { useMsal, MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';

import {  checkGroupsInStorage, getGroupsFromStorage } from './utils/storageUtils';


import AccessDeniedPage from './AccessDeniedPage';
import { loginRequest } from './msalConfig';




export const RouteGuard = ({ Component, ...props }) => {
    const showAccessDeniedPage = props.showAccessDeniedPage === undefined? true: props.showAccessDeniedPage;
    const addOuterDiv = props.addOuterDiv === undefined ? true: props.addOuterDiv;
    const { instance } = useMsal();
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isOveraged, setIsOveraged] = useState(false);
    const [message, setMessage] = useState(null);

    const location = useLocation();
    const { pathname } = location; // <-- access current pathname
    const onLoad = async () => {
        setIsLoading(true);
        const activeAccount = instance.getActiveAccount() || instance.getAllAccounts()[0];

        // check either the ID token or a non-expired storage entry for the groups membership claim
        if (!activeAccount?.idTokenClaims?.groups && !checkGroupsInStorage(activeAccount)) {

            if (activeAccount.idTokenClaims.hasOwnProperty('_claim_names') && activeAccount.idTokenClaims['_claim_names'].hasOwnProperty('groups')) {
                setIsOveraged(true);
                setMessage('You have too many group memberships. The application will now query Microsoft Graph to check if you are a member of any of the groups required.');
                setIsLoading(false);
                return;
            }

            setMessage('Token does not have groups claim. Please ensure that your account is assigned to a security group and then sign-out and sign-in again.');
            setIsLoading(false);
            return;
        }

        
        console.log("show denied page",showAccessDeniedPage);
        const hasRequiredGroup = checkRequiredGroupPresent(props.requiredGroups, activeAccount);

        if (!hasRequiredGroup) setMessage('Please ensure that your account is assigned to the required security group and then sign-out and sign-in again.')
        setIsAuthorized(hasRequiredGroup);
        setIsLoading(false);

        console.log("authorized..", hasRequiredGroup);
    };

    useEffect(() => {
        onLoad();
        // eslint-disable-next-line
    }, [pathname]);


    const authRequest = {
        ...loginRequest,
    };

    return (
        <MsalAuthenticationTemplate 
            interactionType={InteractionType.Redirect} 
            authenticationRequest={authRequest}
        >
            {isLoading ? (
                <div className="flex items-center justify-center min-h-screen">
                    <div className="text-center">
                        <div className="text-xl text-gray-600">Loading...</div>
                    </div>
                </div>
            ) : isAuthorized ? (
                (addOuterDiv ?<div>{props.children}</div>: <>{props.children}</>)
            ) : isOveraged ? (
                <Navigate replace to="/overage" state={location.pathname} />
            ) : (showAccessDeniedPage && AccessDeniedPage(message))}
        </MsalAuthenticationTemplate>
    );
};

// Function to check if active account is part of required Security Group
export const checkRequiredGroupPresent = (requiredGroups, activeAccount) => {
    console.log("required groups",requiredGroups);
        console.log("user groups:",activeAccount?.idTokenClaims?.groups);
    return requiredGroups.some((group) =>
        activeAccount?.idTokenClaims?.groups?.includes(group) || getGroupsFromStorage(activeAccount)?.includes(group));
    
}